exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-display-profile-card .display-profile-card-trigger[data-v-3824be24]{color:var(--fts-primary);cursor:pointer}.display-profile-card-content[data-v-3824be24]{width:300px;max-width:300px;display:flex;align-items:flex-start;padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.display-profile-card-content .profile-card-photo[data-v-3824be24]{flex-shrink:0;margin-right:.375rem}.display-profile-card-content .profile-card-info[data-v-3824be24]{font-size:.75rem;overflow-wrap:anywhere;word-break:break-all}.display-profile-card-content .profile-card-username[data-v-3824be24]{color:var(--fts-default)}", ""]);

// exports
